import { httpClient } from '@/core/api/httpClient';
import { env } from '@/core/config/env';

export interface SupportMessage {
  id: string;
  tenantId: string;
  senderType: 'Tenant' | 'Platform' | 'Bale';
  senderDisplayName: string;
  message: string;
  channel: 'InApp' | 'Bale';
  sentAtUtc: string;
  readAtUtc: string | null;
  readByDisplayName: string | null;
  attachmentId: string | null;
  imageUrl: string | null;
  imageFileName: string | null;
}

export interface SupportImageUpload {
  id: string;
  url: string;
  fileName: string;
  contentType: string;
  size: number;
}

export interface TenantSupportConversation {
  messages: SupportMessage[];
  isBaleLinked: boolean;
  baleChatDisplayName: string | null;
  baleLinkedAtUtc: string | null;
}

export interface TenantBaleLink {
  isLinked: boolean;
  chatDisplayName: string | null;
  linkedAtUtc: string | null;
  startCommand: string;
  deepLink: string | null;
}

export const tenantSupportApi = {
  conversation: async (): Promise<TenantSupportConversation> => {
    if (env.isDemo) return { messages: [], isBaleLinked: false, baleChatDisplayName: null, baleLinkedAtUtc: null };
    return (await httpClient.get<TenantSupportConversation>('/api/v1/tenant-support/conversation')).data;
  },
  send: async (message: string | null, attachmentId: string | null = null): Promise<SupportMessage> =>
    (await httpClient.post<SupportMessage>('/api/v1/tenant-support/messages', { message, attachmentId })).data,
  uploadImage: async (file: File): Promise<SupportImageUpload> => {
    const body = new FormData();
    body.append('file', file);
    return (await httpClient.post<SupportImageUpload>('/api/v1/tenant-support/images', body)).data;
  },
  createBaleLink: async (): Promise<TenantBaleLink> =>
    (await httpClient.post<TenantBaleLink>('/api/v1/tenant-support/bale-link', {})).data,
};
